import Vue from "vue";
import Component from "vue-class-component";
import { MedicalInvoice } from "@/components/medicalEdit/types";
import { PulldownItem } from "@/types";
import { Prop } from "vue-property-decorator";

@Component
export default class MedicalInvoiceBase extends Vue {
  @Prop() tab!: MedicalInvoice;
  @Prop() visit_count_items!: PulldownItem[]; //訪問回数アイテムリスト
  @Prop() indicate_day_items!: PulldownItem[]; //特指示アイテムリスト
  @Prop() long_day_items!: PulldownItem[]; //長時間アイテムリスト
  @Prop() multi_day_items!: PulldownItem[]; //複数日アイテムリスト
  @Prop() same_building_day_items!: PulldownItem[]; //同一建物アイテムリスト
  @Prop() same_emergency_day_items!: PulldownItem[]; //同一緊急アイテムリスト
  @Prop() tax_rate_items!: PulldownItem[]; //税率アイテムリスト

  //保険適用負担削除
  deleteInsIn(index: number) {
    if (
      window.confirm(
        "「" +
        this.tab.burden_ins_ins[index].item +
        "」を削除します。よろしいですか？"
      )
    ) {
      this.tab.burden_ins_ins.splice(index, 1);
    }
  }

  //保険適用負担追加
  addInsIn() {
    const length = this.tab.burden_ins_ins.length;
    this.tab.burden_ins_ins.push({
      id: 0,
      medical_invoice_id: this.tab.id,
      yearmonth: this.tab.yearmonth,
      office_ibow_unique_id: this.tab.office_ibow_unique_id,
      order: length,
      item: "",
      unit_price: 0,
      unit_num: 0,
      total_money: 0,
      created_at: null,
      updated_at: null,
      deleted_at: null
    });
  }

  //保険適用外負担削除
  deleteInsOut(index: number) {
    if (
      window.confirm(
        "「" +
        this.tab.burden_ins_outs[index].item +
        "」を削除します。よろしいですか？"
      )
    ) {
      this.tab.burden_ins_outs.splice(index, 1);
    }
  }

  //保険適用外負担追加
  addInsOut() {
    const length = this.tab.burden_ins_ins.length;
    this.tab.burden_ins_outs.push({
      id: 0,
      medical_invoice_id: this.tab.id,
      yearmonth: this.tab.yearmonth,
      office_ibow_unique_id: this.tab.office_ibow_unique_id,
      order: length,
      item: "",
      unit_price: 0,
      unit_num: 0,
      total_money: 0,
      tax: 0,
      tax_money: 0,
      created_at: null,
      updated_at: null,
      deleted_at: null
    });
  }

  //保険適用負担更新
  updateTotalIns() {
    this.tab.ins_cost_total_org = Math.floor(this.getTotalIns());
    this.tab.ins_cost_total = Math.round(this.tab.ins_cost_total_org / 10) * 10
    this.tab.cost_total = this.tab.ins_cost_total + this.tab.self_cost_total;
  }

  //保険適用負担外更新
  updateTotalOuts() {
    this.tab.self_cost_total = this.tab.burden_ins_outs.reduce(
      (ac, cu) => ac + cu.total_money,
      0
    );
    this.tab.tax8 = this.tab.burden_ins_outs.reduce(
      (ac, cu) => (cu.tax == 8 ? ac + cu.tax_money : ac),
      0
    );
    this.tab.tax10 = this.tab.burden_ins_outs.reduce(
      (ac, cu) => (cu.tax == 10 ? ac + cu.tax_money : ac),
      0
    );
    this.tab.cost_total = this.tab.ins_cost_total + this.tab.self_cost_total;
  }

  //保険適用負担
  getTotalIns(): number {
    const ins_const_total = this.tab.burden_ins_ins.reduce(
      (ac, cu) => ac + cu.total_money,
      0
    );
    if (this.tab.is_self_burden) {
      //上限あり(負担割合が0の場合、10割として計算する)
      let burden = this.tab.burden_rate; 
      if (!burden) {
        burden = 10
      }
      if ((ins_const_total * burden) / 10 > this.tab.self_burden!!) {
        return this.tab.self_burden!!;
      }
    }
    return (ins_const_total * this.tab.burden_rate) / 10;
  }
}
